import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import classes from "./AllClients.module.scss";
import { Tooltip, ButtonToolbar, OverlayTrigger } from "react-bootstrap";
import ClientModal from "../components/profileComponents/ClientModal";
import { OrgIdContext } from "../store/orgId_context";
import { ReactComponent as EditBtn } from "../assets/enter.svg";
import { ReactComponent as CopyBtn } from "../assets/copy.svg";
import LoadingDots from "../components/UI/LoadingDots";
import useClients from "../hooks/useClients";
import { useCallback } from "react";
import { DDD } from "../lib/ddd/ddd";
import { initRpcClient } from "../lib/ddd/RPCAxiosClient";
import ClientModal2 from "../components/profileComponents/ClientModal2";
import AddCustomer from "../components/clientsComponents/AddCustomer";
import Button from "../components/UI/Button";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ModalWindow from "../components/UI/ModalWindow";
import ClientsGridContainer from "../components/clientsComponents/ClientsGridContainer";
import { Hourglass } from "react-loader-spinner";
import CustomersGrid from "../components/table/CustomersGrid";
import { useTranslation } from 'react-i18next';
import { useLocation,useNavigate } from 'react-router-dom';
import { NotificationManager} from 'react-notifications';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CallSplitIcon from '@mui/icons-material/CallSplit';
import MergeIcon from '@mui/icons-material/Merge';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import JoinInnerIcon from '@mui/icons-material/JoinInner';


const tooltip = (
  <Tooltip id="growth-tooltip">
    Growth of e-invoices this month compared to last month
  </Tooltip>
);

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
let __intervalId = null;
let __createdClients = [];
const AllClients = ({iframeUrl="/mycompany"}) => {
  // const [clientsList, setClientsList] = useState(null);
  // const [isLoaded, setIsLoaded] = useState(false);
  const [isInClientMode, setIsInClientMode] = useState(false);
  const [orgName, setOrgName] = useState(null);
  const [clientConnKey, setClientConnKey] = useState(null);
  const [isClientInfoLoaded, setIsClientInfoLoaded] = useState(null);
  const [clientError, setClientError] = useState(undefined);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [searchClients, setSearchClients] = useState([]);
  const [modalShow, setModalShow] = useState();
  const { t } = useTranslation();

  const [clientMode, setClientMode] = useState();
  const [activeOrgId, setActiveOrgId] = useState();
  const [activeOrgKey, setActiveOrgKey] = useState();
  const [createdClients, setCreatedClients] = useState([]);
  const [intervalId, setIntervalId] = useState();
  const [search, setSearch] = useState();
  const [reloadNum, setReloadNum] = useState(0);
  const { mainOrgId } = useContext(OrgIdContext);
  const [customerChangeType, setCustomerChangeType] = useState();
  const [activeButton, setActiveButton] = useState(1);
  const [filter, setFilter] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    return () => {
      ddd.ChangeOrganization(mainOrgId).then((res)=>{
        onCloseModal();
      })
    }
  }, [location, navigate]);


  const setSearchClientsHandler = useCallback(
    (clientsList) => setSearchClients(clientsList),
    []
  );

  

  const connectionKeyRef = useRef([]);

  const { clientsList, isLoaded, reload } = useClients(setSearchClientsHandler);

  const copyConnectionKey = (index) => {
    navigator.clipboard.writeText(connectionKeyRef.current[index].textContent);

    setCopiedIndex(index);
    setTimeout(() => {
      setCopiedIndex(null);
    }, 1500);
  };

  const onRemoveClientConnKey = () => setClientConnKey(null);

  const openClientInfoHandler = (id, connKey) => {
    setIsInClientMode(true);
    setClientError(false);
    setIsClientInfoLoaded(false);
    setOrgName(null);
    setClientConnKey(connKey);
    // setClientOrgHandler(id);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Auth.ChangeOrganization",
          params: {
            orgid: `${id}`,
          },
          id: 26,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setIsClientInfoLoaded(true);
        if (res.data.error) setClientError(true);
        else {
          axios
            .post(
              apiRequestAddress,
              {
                jsonrpc: "2.0",
                method: "Auth.GetSessionInfo",
                params: {
                  includeExtendedInfo: true,
                },
                id: 27,
              },
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              setOrgName(res?.data?.result?.Organization?.Title);
            });
        }
      });
  };

  const closeClientModeHandler = () => {
    setIsInClientMode(false);
  };

  const onSearchUserHandler = (e) => {
    const searchHandle = e.target.value.toLowerCase();
    return setSearch(searchHandle);
  };

  const openClientInfoHandler2 = (id, key) => {
    setClientMode(true);
    setActiveOrgId(id);
    setActiveOrgKey(key);
  }

  const onCloseModal = () =>{
    setActiveOrgId(null);
    setActiveOrgKey(null);
    setClientMode(false);
  }

  const onCustomerCreated = (conKey) =>{
    setCreatedClients([...createdClients, conKey]);
    if(intervalId) return;
    let _interval = setInterval(() =>{
      checkClientsRefreshInterval();
    }, 5000);
    setIntervalId(_interval);
  }

  const changeClientType = (data) =>{
    if(!data) return;
    setCustomerChangeType(data);
  }

  const confirmClientChange = (data) =>{
    setCustomerChangeType(null);
    const ddd = DDD.WithConnectionKey(apiRequestAddress, data.ConnectionKey);
    ddd.Rpc_ExecuteExtension("EUeInvoices.ISVChangeClientType", {IsCompany : data?.ClientType === "Company" ? false : true}).then(res =>{
      if(res?.result?.Status === "OK"){
        NotificationManager.success(t("Customer relations changed successfully"), t("Success"));
        setReloadNum(reloadNum+1);
        reload();
      }else{
        NotificationManager.error(res?.result?.Reason || t("An unknown error has occured."), t("Error"));
      }
    });
  }

  __intervalId = intervalId;
  __createdClients = createdClients;
  const checkClientsRefreshInterval = () =>{
    if(!__intervalId || __createdClients.length===0) return console.error(1);

    let filter = "";
    for(let i=0;i<__createdClients.length;i++){
      filter += `ConnectionKey = '${__createdClients[i]}'`
      if(i+1 !== __createdClients.length)
        filter += " AND ";
    }

    ddd.Rpc_ExecuteExtension("EUeInvoices.GetTCustomers", {Filter : filter}).then(res =>{console.log(res);
      if(res?.result?.Result){
        let newConnKeys = [];
        __createdClients.forEach(item => {
          if(!res?.result?.Result.find(srvItem => srvItem.ConnectionKey === item))
            newConnKeys.push(item);
        })
        
        setCreatedClients(newConnKeys);

        if(newConnKeys.length === 0){
          reload();
          setReloadNum(reloadNum+1);
          clearInterval(__intervalId);
        }
      }
    });
  }

  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
    if(buttonId === 1)
      return setFilter(null);
    if(buttonId === 2)
      return setFilter("ClientType = null");
    if(buttonId === 3)
      return setFilter("ClientType = 'Company'");
  };

  return (
    <>
      <Helmet>
        <title>Customers | DDD Invoices</title>
      </Helmet>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={customerChangeType}>
          <DialogTitle>{t("Confirm change")}</DialogTitle>
          <DialogContent dividers>
            <div>{t("Are you certain you with to change relationship with this customer?")}</div>
            <div className="d-flex align-items-end mt-2 justify-content-center">
              <div className="ms-2 fw-bold text-center fs-5" style={{color:"var(--main-blue)"}}>{customerChangeType?.Organisation}</div>
            </div>
            <div className="mt-2">
              {customerChangeType?.ClientType === "Company" && <div>{t("Any invoices issued by this customer will be counted as your invoice consumption. The customer will not handle any payments or billing with us.")}</div>}
              {customerChangeType?.ClientType === null && <div>{t("This customer will have to handle its own payments and billings.")}</div>}
            </div>
          </DialogContent>
          <DialogActions>
            <Button className="ps-2 pe-2" autoFocus onClick={() => setCustomerChangeType(null)}>
              {t("Cancel")}
            </Button>
            <Button className="ps-4 pe-4 bg-danger" onClick={() => {confirmClientChange({...customerChangeType})}}>Ok</Button>
          </DialogActions>
      </Dialog>
      <div className={`w-100 h-100 p-5 ${classes.container}`}>
              <div className="w-100 d-flex ">
                <h2 className={`${classes.title} mb-2`}>{t("My customers")}</h2>
                <div className="d-flex justify-content-end align-items-end ms-3">
                  <div className="d-flex gap-2">
                  <OverlayTrigger placement="top" overlay={<Tooltip>{t("Show all of my customers")}</Tooltip>}>
                  <button className={`btn fs-8 pe-2 ps-2 ${activeButton === 1 ? classes['filter-button'] : classes['filter-button-s']} rounded-pill p-0`} style={{ width: 'fit-content', height: 'fit-content' }} onClick={() => handleButtonClick(1)}>
                    {t("All")}
                  </button>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>{t("Show customers billed through me and included in my plan.")}</Tooltip>}>
                    <button className={`btn fs-8 pe-2 ps-2  ${activeButton === 2 ? classes['filter-button'] : classes['filter-button-s']} rounded-pill p-0`} style={{ width: 'fit-content', height: 'fit-content' }} onClick={() => handleButtonClick(2)}>
                      <JoinFullIcon style={{fontSize:"0.7rem", marginRight:"0.3rem"}}/>{t("Billed through me")}
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>{t("Show customers billed directly by DDD Invoices.")}</Tooltip>}>
                  <button className={`btn fs-8 pe-2 ps-2  ${activeButton === 3 ? classes['filter-button'] : classes['filter-button-s']} rounded-pill p-0`} style={{ width: 'fit-content', height: 'fit-content' }} onClick={() => handleButtonClick(3)}>
                    <JoinInnerIcon style={{fontSize:"0.7rem", marginRight:"0.3rem"}}/>{t("Billed by DDD")}
                  </button>
                  </OverlayTrigger>
                  </div>
                </div>
                <input
                  className="ms-auto"
                  type="text"
                  placeholder={t("Search customer")}
                  onChange={onSearchUserHandler}
                />
                <div style={{marginLeft:"1rem"}}>
                  <Button onClick={() => setModalShow(true)}>
                    <PersonAddIcon/>
                  </Button>
                  <ModalWindow show={modalShow} onHide={() => setModalShow(false)}>
                    <AddCustomer onCustomerCreated={onCustomerCreated}/>
                  </ModalWindow>
                </div>
                <div>
                  
                </div>
              </div>
              {createdClients.length > 0 && <>
                <div className="alert alert-success d-flex mt-3 flex-wrap" role="alert">
                  <Hourglass height="1.5rem" width="1.5rem" colors={['#005683', '#df511d']}/>
                  {t("Please wait while we create your customer. This should not take more then a few minutes")}:
                  {createdClients.map((item,index) => {
                    return (<>
                      <span className="ms-1 me-1">
                        {item}
                        {index+1 !== createdClients.length && <>,</>}
                      </span>
                      </>)
                  })}
                </div>
              </>}
              
              <div className="h-100 w-100 mt-4">
                <CustomersGrid openClientInfoHandler={openClientInfoHandler2} search={search} filter={filter} changeClientType={changeClientType} reloadNum={reloadNum}/>
              </div>
              {/* <div className={`w-100 mt-2 ${classes["clients-table-container"]}`}>
                <table className={`w-100 ${classes["clients-table"]}`}>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Organization</th>
                      <th>Connection Key</th>
                      <th>Contact</th>
                      <th>This Month</th>
                      <th>Last Month</th>
                      <th>
                        <div className={classes["growth-container"]}>
                          Growth
                          <ButtonToolbar>
                            <OverlayTrigger placement="left" overlay={tooltip}>
                              <button>
                                <svg
                                  height="15"
                                  viewBox="0 0 19 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                                    fill="#00436D"
                                  />
                                  <path
                                    d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                                    fill="#00436D"
                                  />
                                </svg>
                              </button>
                            </OverlayTrigger>
                          </ButtonToolbar>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchClients.map((client, index) => {
                      return (
                        <tr key={`client-no-${index}`}>
                          <th
                            className={`${classes["conn-key"]} text-start ps-3`}
                            onClick={() =>
                              openClientInfoHandler2(
                                client.CustomerId,
                                client.ConnectionKey
                              )
                            }
                          >
                            <EditBtn />
                          </th>
                          <th
                            className={`${classes["conn-key"]} ${classes.orgName} text-start ps-3`}
                            style={{ lineHeight: "1.5rem" }}
                            onClick={() =>
                              openClientInfoHandler2(
                                client.CustomerId,
                                client.ConnectionKey
                              )
                            }
                          >
                            <span>{client.Organisation}</span>
                          </th>
                          <th
                            onClick={() => copyConnectionKey(index)}
                            className={`${classes["conn-key"]} d-flex align-items-center justify-content-center gap-2`}
                          >
                            <div className={classes.overflowContainer}>
                              <span
                                ref={(ref) =>
                                  (connectionKeyRef.current[index] = ref)
                                }
                              >
                                {client.ConnectionKey}
                              </span>
                            </div>
                            <div style={{ position: "relative" }}>
                              <CopyBtn height="15" fill="#00436D" />
                              {index === copiedIndex && (
                                <span className={classes.copiedMsg}>
                                  Copied!
                                </span>
                              )}
                            </div>
                          </th>
                          <th>{client.eMail || "/"}</th>
                          <th>{client.ThisMonth || "0"}</th>
                          <th>{client.LastMonth || "0"}</th>
                          <th>
                            {client.ThisMonth && client.LastMonth
                              ? `${(
                                  ((client.ThisMonth - client.LastMonth) *
                                    100) /
                                  client.LastMonth
                                ).toFixed(2)}%`
                              : "0%"}
                          </th>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div> */}
            
        {isInClientMode && (
          <ClientModal
            closeClientModeHandler={closeClientModeHandler}
            orgName={orgName}
            isLoaded={isClientInfoLoaded}
            error={clientError}
            connKey={clientConnKey}
            removeConnKey={onRemoveClientConnKey}
          />
        )}
        {clientMode && 
          <ClientModal2
            orgId = {activeOrgId}
            orgKey = {activeOrgKey}
            onClose = {onCloseModal}
            iframeUrl = {iframeUrl}
        />}
      </div>
    </>
  );
};

export default AllClients;
